import React, { useEffect, useState } from 'react';
import { getDoc } from 'firebase/firestore';
import { motion } from 'framer-motion';
import { configDoc } from '../db';

interface Props {
  coupleId: string;
  onStart: () => void;
}

interface CoupleInfo { person1Name?: string; person2Name?: string; }

function parseCoupleId(id: string): [string, string] {
  const parts = id.split('-');
  const cap = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);
  if (parts.length >= 2) return [cap(parts[0]), cap(parts.slice(1).join('-'))];
  return [cap(id), ''];
}

export default function Welcome({ coupleId, onStart }: Props) {
  const [names, setNames] = useState<[string, string]>(parseCoupleId(coupleId));

  useEffect(() => {
    getDoc(configDoc(coupleId)).then(snap => {
      if (snap.exists()) {
        const d = snap.data() as CoupleInfo;
        if (d.person1Name && d.person2Name) setNames([d.person1Name, d.person2Name]);
      }
    }).catch(() => {});
  }, [coupleId]);

  return (
    <div className="welcome-screen">
      <motion.div
        className="welcome-card"
        initial={{ opacity: 0, y: 18, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        transition={{ duration: 0.45 }}
      >
        <div className="welcome-url">@{coupleId}</div>
        <div className="welcome-logo">S+A</div>
        <p className="eyebrow">Kişiye özel alan</p>
        <h1>{names[1] ? `${names[0]} & ${names[1]}` : names[0]}</h1>
        <p>
          Günlük sorular, gece notları, anılar, şarkılar ve küçük sinyaller.
          Sadece ikinizin ritmi için tasarlandı.
        </p>

        <div className="welcome-points">
          <span>Günlük soru</span>
          <span>Bizim minik dost</span>
          <span>Anı zaman çizgisi</span>
          <span>Tek dokunuşla sevgi</span>
        </div>

        <button className="feature-primary" onClick={onStart}>Alana gir</button>
      </motion.div>
    </div>
  );
}
